import {
  Image,
  Modal,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppImages } from "../../../../utility/AppImages";
import Ionicons from "@expo/vector-icons/Ionicons";
import { useCallback, useEffect, useRef, useState } from "react";
import { Picker } from "@react-native-picker/picker";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import DateTimePicker from "react-native-ui-datepicker";
import { s } from "react-native-size-matters";
import DateTimePickerModal from "../Common/DateTimePickerModal";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { getDateDiffereceInMinutes } from "../../../../utility/Index";
import React from "react";

export default function AddEventDetails(props) {
  const {
    showModal = false,
    setShowModal,
    setCompetitorModel,
    setData,
    apiData = {},
    isUpdate = false,
    userData,
  } = props;

  const [dateTimeInput, setDateTimeInput] = useState("");
  const [ticketPrice, setTicketPrice] = useState("");
  const [duration, setDuration] = useState("");
  const [numberOfAttendee, setNumberOfAttendee] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [playType, setPlayType] = useState("Competitive");
  const [gameType, setGameType] = useState("Fortnite");

  const onCloseClick = () => {
    setShowModal(false);
  };

  const playTypePickerRef = useRef();

  const styles = useStyles();
  const deviceSize = useDeviceSize();

  const [showDatePicker, setShowDatePicker] = useState(false);

  useEffect(() => {
    if (isUpdate) {
      if (apiData) {
        // setDateTimeInput(apiData.startDateTime);
        setTicketPrice(apiData.ticketPrice);
        setDuration(apiData.duration);
        setNumberOfAttendee(apiData.minimumAttendees);
        setTitle(apiData.title);
        setDescription(apiData.description);
        setPlayType(apiData.type);
        setGameType(apiData.gameTitle);
        if (apiData.startDateTime && apiData.endDateTime) {
          const min = getDateDiffereceInMinutes(
            apiData.startDateTime,
            apiData.endDateTime
          );
          setDuration(min.toString());
        }
        if (apiData.startDateTime) {
          const date = new Date(apiData.startDateTime);
          const formatedStartDate = dayjs(date).format("YYYY-MM-DD HH:mm");
          setDateTimeInput(formatedStartDate);
        }
      }
    }
  }, [isUpdate, apiData]);
  function checkValidation() {
    if (dateTimeInput === "") {
      toast.error("Please select date and time");
    } else if (duration === "") {
      toast.error("Please enter duration in minutes");
    } else if (ticketPrice === "") {
      toast.error("Please enter ticket price");
    } else if (numberOfAttendee === "") {
      toast.error("Please enter minimum number of attendees");
    } else if (title === "") {
      toast.error("Please enter title");
    } else if (description === "") {
      toast.error("Please enter description");
    } else if (playType === "") {
      toast.error("Please select play type");
    } else if (gameType === "") {
      toast.error("Please select game type");
    } else {
      const date = new Date(dateTimeInput);

      const date1 = dayjs(date).add(parseInt(duration), "minute");

      const formatedStartDate = dayjs(dateTimeInput).format(
        "YYYY-MM-DDTHH:mm:ss[Z]"
      );
      const formatedEndDate = dayjs(date1).format("YYYY-MM-DDTHH:mm:ss[Z]");

      const eventDetails = {
        title: title,
        description: description,
        startDateTime: formatedStartDate,
        endDateTime: formatedEndDate,
        organiserID: userData.username != null ? userData.username : "",
        type: playType,
        minimumAttendees: numberOfAttendee,
        gameTitle: gameType,
        ticketPrice: ticketPrice,
      };
      if (isUpdate) {
        eventDetails["participantIDs"] = apiData.participantIDs;
        apiData.captinIDs && (eventDetails["captinIDs"] = apiData.captinIDs);
      }
      setData(eventDetails);
      setShowModal(false);
      setCompetitorModel(true);
    }
  }
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View style={styles.container}>
        <View style={styles.mainView}>
          <View style={{ flexDirection: "row", paddingTop: 20 }}>
            <Text style={[AppFontStyle.BOLD_ANYBODY_32, { flex: 1 }]}>
              Event details
            </Text>
            <Ionicons
              name="close"
              size={35}
              color={AppColors.white}
              onPress={onCloseClick}
            />
          </View>

          <View
            style={{
              height: 2,
              marginTop: 20,
              backgroundColor: AppColors.appGrayColor_1C1C1C,
              width: "100%",
            }}
          />
          <ScrollView showsVerticalScrollIndicator={false}>
            <View>
              <View style={styles.thumbViewWrapper}>
                {/* Thumbnail Field */}
                <TouchableOpacity
                  activeOpacity={0.8}
                  style={{
                    flex: 1,
                    borderRadius: 15,
                    backgroundColor: AppColors.appGrayColor_1C1C1C,
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      {
                        color: AppColors.gray_C3C3C3,
                        padding: 10,
                      },
                    ]}
                  >
                    Thumbnail
                  </Text>
                  <View
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      paddingTop: 50,
                      paddingBottom: 80,
                    }}
                  >
                    <Image
                      source={AppImages.thumbnailIcon}
                      style={{
                        height: 20,
                        width: 20,
                        alignSelf: "center",
                        resizeMode: "contain",
                      }}
                    />
                  </View>
                </TouchableOpacity>

                <View
                  style={{
                    flex: 1,
                    gap: 10,
                  }}
                >
                  <TouchableOpacity
                    style={styles.inputWrapper}
                    onPress={() => setShowDatePicker(true)}
                    activeOpacity={0.9}
                  >
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        styles.headerTitle,
                      ]}
                    >
                      Date and time
                    </Text>
                    <TextInput
                      placeholder={""}
                      multiline={false}
                      placeholderTextColor={AppColors.white}
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        styles.textInputStyle,
                      ]}
                      editable={false}
                      // ref={refValue}
                      onSubmitEditing={() => {}}
                      onChangeText={setDateTimeInput}
                      keyboardType="default"
                      secureTextEntry={false}
                      value={dateTimeInput}
                    />
                  </TouchableOpacity>

                  <View
                    style={{
                      flexDirection: "row",
                      gap: 5,
                    }}
                  >
                    <View style={[styles.inputWrapper, { flex: 1 }]}>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          styles.headerTitle,
                        ]}
                      >
                        Duration in minutes
                      </Text>

                      <TextInput
                        placeholder={""}
                        multiline={false}
                        placeholderTextColor={AppColors.white}
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_14,
                          styles.textInputStyle,
                        ]}
                        // ref={refValue}
                        onChange={(e) => {
                          const value = e.nativeEvent.text;

                          if (!isNaN(+value)) {
                            setDuration(value);
                          }
                        }}
                        onSubmitEditing={() => {}}
                        keyboardType="numeric"
                        secureTextEntry={false}
                        value={duration}
                      />
                    </View>
                    <View style={[styles.inputWrapper, { flex: 1 }]}>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          styles.headerTitle,
                        ]}
                      >
                        Ticket price
                      </Text>
                      <TextInput
                        placeholder={""}
                        multiline={false}
                        placeholderTextColor={AppColors.white}
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_14,
                          styles.textInputStyle,
                        ]}
                        // ref={refValue}
                        onSubmitEditing={() => {}}
                        onChange={(e) => {
                          const value = e.nativeEvent.text;

                          if (!isNaN(+value)) {
                            setTicketPrice(value);
                          }
                        }}
                        keyboardType="number-pad"
                        secureTextEntry={false}
                        textContentType="telephoneNumber"
                        value={ticketPrice}
                      />
                    </View>
                  </View>

                  <View style={styles.inputWrapper}>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        styles.headerTitle,
                      ]}
                    >
                      Minimum number of attendees
                    </Text>
                    <TextInput
                      placeholder={""}
                      multiline={false}
                      placeholderTextColor={AppColors.white}
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        styles.textInputStyle,
                      ]}
                      // ref={refValue}
                      onSubmitEditing={() => {}}
                      onChangeText={setNumberOfAttendee}
                      keyboardType="numeric"
                      secureTextEntry={false}
                      value={numberOfAttendee}
                    />
                  </View>
                </View>
              </View>
              <View
                style={{
                  flexDirection: "column",
                  gap: 16,
                }}
              >
                {/* Title field */}
                <View style={[styles.inputWrapper, { marginHorizontal: 10 }]}>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      styles.headerTitle,
                    ]}
                  >
                    Title
                  </Text>
                  <TextInput
                    placeholder={""}
                    multiline={false}
                    placeholderTextColor={AppColors.white}
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_18,
                      styles.textInputStyle,
                    ]}
                    // ref={refValue}
                    onSubmitEditing={() => {}}
                    onChangeText={setTitle}
                    keyboardType="default"
                    secureTextEntry={false}
                    value={title}
                  />
                </View>

                {/* Description field */}
                <View style={[styles.inputWrapper, { marginHorizontal: 10 }]}>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      styles.headerTitle,
                    ]}
                  >
                    Description
                  </Text>
                  <TextInput
                    placeholder={""}
                    multiline={true}
                    numberOfLines={10}
                    placeholderTextColor={AppColors.white}
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      styles.textInputStyle,
                    ]}
                    // ref={refValue}
                    onSubmitEditing={() => {}}
                    onChangeText={setDescription}
                    keyboardType="default"
                    secureTextEntry={false}
                    value={description}
                  />
                </View>

                <View style={styles.gameWrapper}>
                  <View style={[styles.inputWrapper, { flex: 1 }]}>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        styles.headerTitle,
                      ]}
                    >
                      Game
                    </Text>
                    <Picker
                      selectedValue={gameType}
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        styles.dropDownStyle,
                      ]}
                      onValueChange={(itemValue, itemIndex) =>
                        setGameType(itemValue)
                      }
                    >
                      <Picker.Item
                        style={[AppFontStyle.REGULAR_ANYBODY_18]}
                        label="Fortnite"
                        value="Fortnite"
                      />
                      <Picker.Item
                        style={[AppFontStyle.REGULAR_ANYBODY_18]}
                        label="Valorant"
                        value="Valorant"
                      />
                    </Picker>
                  </View>

                  <View style={[styles.inputWrapper, { flex: 1 }]}>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        styles.headerTitle,
                      ]}
                    >
                      Play type
                    </Text>
                    <Picker
                      selectedValue={playType}
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        styles.dropDownStyle,
                      ]}
                      onValueChange={(itemValue, itemIndex) =>
                        setPlayType(itemValue)
                      }
                    >
                      <Picker.Item
                        style={[AppFontStyle.REGULAR_ANYBODY_18]}
                        label="Competitive"
                        value="competitive"
                      />
                      <Picker.Item
                        style={[AppFontStyle.REGULAR_ANYBODY_18]}
                        label="Casual"
                        value="casual"
                      />
                      <Picker.Item
                        style={[AppFontStyle.REGULAR_ANYBODY_18]}
                        label="Tournament"
                        value="tournament"
                      />
                    </Picker>
                  </View>
                </View>
                <View
                  style={{
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                    marginHorizontal: 10,
                  }}
                >
                  <TouchableOpacity
                    style={{
                      backgroundColor: AppColors.appViolentColor_6D08C3,
                      borderRadius: 10,
                      marginBottom: 30,
                    }}
                    onPress={() => {
                      checkValidation();
                    }}
                    activeOpacity={0.5}
                  >
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_12,
                        {
                          paddingVertical: 12,
                          paddingHorizontal: 18,
                          color: AppColors.white,
                        },
                      ]}
                    >
                      Next
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </ScrollView>
        </View>
        {
          <DateTimePickerModal
            showModal={showDatePicker}
            setShowModal={setShowDatePicker}
            selectedDate={(date) => {
              setDateTimeInput(date);
            }}
            timePicker={true}
          />
        }
      </View>
    </Modal>
  );
}

// const styles = StyleSheet.create({
const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
    },
    mainView: {
      width: "50%",
      height: "90%",
      backgroundColor: AppColors.black_121212,
      paddingHorizontal: 20,
      margin: 30,
      alignSelf: "center",
      borderRadius: 12,
    },
    thumbViewWrapper: {
      flexDirection: "row",
      marginHorizontal: 10,
      marginVertical: 16,
      gap: 20,
    },
    textInputStyle: {
      paddingTop: 5,
      paddingBottom: 18,
      color: AppColors.white,
      flex: 1,
      outlineStyle: "none",
    },
    inputWrapper: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      paddingHorizontal: 12,
      borderRadius: 10,
    },
    headerTitle: {
      color: AppColors.gray_C3C3C3,
      paddingTop: 10,
    },
    gameWrapper: {
      flex: 1,
      flexDirection: "row",
      marginHorizontal: 10,
      gap: 20,
    },
    dropDownStyle: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      borderColor: AppColors.appGrayColor_1C1C1C,
      paddingTop: 5,
      paddingBottom: 18,
      color: AppColors.white,
      flex: 1,
      outlineStyle: "none",
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "80%",
        height: "90%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 20,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      thumbViewWrapper: {
        flexDirection: "row",
        marginHorizontal: 10,
        marginVertical: 16,
        gap: 20,
      },
      textInputStyle: {
        paddingTop: 5,
        paddingBottom: 18,
        color: AppColors.white,
        flex: 1,
      },
      inputWrapper: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 10,
      },
      gameWrapper: {
        flex: 1,
        flexDirection: "row",
        marginHorizontal: 10,
        gap: 20,
      },
      dropDownStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        borderColor: AppColors.appGrayColor_1C1C1C,
        paddingTop: 5,
        paddingBottom: 18,
        color: AppColors.white,
        flex: 1,
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "70%",
        height: "90%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 20,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      thumbViewWrapper: {
        flexDirection: "row",
        marginHorizontal: 10,
        marginVertical: 16,
        gap: 20,
      },
      textInputStyle: {
        paddingTop: 5,
        paddingBottom: 18,
        color: AppColors.white,
        flex: 1,
      },
      inputWrapper: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 10,
      },
      gameWrapper: {
        flex: 1,
        flexDirection: "row",
        marginHorizontal: 10,
        gap: 20,
      },
      dropDownStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        borderColor: AppColors.appGrayColor_1C1C1C,
        paddingTop: 5,
        paddingBottom: 18,
        color: AppColors.white,
        flex: 1,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "90%",
        height: "90%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 20,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      thumbViewWrapper: {
        flexDirection: "column",
        marginHorizontal: 10,
        marginVertical: 16,
        gap: 20,
      },
      textInputStyle: {
        paddingTop: 5,
        paddingBottom: 18,
        color: AppColors.white,
        flex: 1,
      },
      inputWrapper: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 10,
      },
      gameWrapper: {
        flex: 1,
        flexDirection: "row",
        marginHorizontal: 10,
        gap: 20,
      },
      dropDownStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        borderColor: AppColors.appGrayColor_1C1C1C,
        paddingTop: 5,
        paddingBottom: 18,
        color: AppColors.white,
        flex: 1,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "90%",
        height: "90%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 16,
        margin: 16,
        alignSelf: "center",
        borderRadius: 12,
      },
      thumbViewWrapper: {
        flexDirection: "column",
        marginHorizontal: 10,
        marginVertical: 16,
        gap: 20,
      },
      textInputStyle: {
        paddingTop: 5,
        paddingBottom: 18,
        color: AppColors.white,
        flex: 1,
      },
      inputWrapper: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 10,
      },
      gameWrapper: {
        flex: 1,
        flexDirection: "column",
        marginHorizontal: 10,
        gap: 20,
      },
      dropDownStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        borderColor: AppColors.appGrayColor_1C1C1C,
        paddingTop: 5,
        paddingBottom: 18,
        color: AppColors.white,
        flex: 1,
      },
    },
  }
);
